import { ViewerFragment } from '@/__generated__/graphql';
import iconDiamond from '@/components/diamonds/images/icon_gem.png';
import ItemPoint from '@/components/home/IeltsHeader/ItemPoint';
import iconPlus1 from '@/components/home/assets/icon_plus1.png';
import DiamondPopover from '@/components/packages/components/DiamondPopover';
import ROUTES from '@/lib/routes';
import { usePreRoute } from '@/providers/pre-route';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

type Props = {
  className?: string;
  checkPointInfo?: {
    name?: string | null;
    nameEn?: string | null;
  } | null;
  user?: ViewerFragment | null;
};

export default function HeaderPartInfo({ className, checkPointInfo, user }: Props) {
  const { lang } = useTranslation('common');
  const { goBackOrHome } = usePreRoute();
  const router = useRouter();

  const handleBack = () => {
    if (router.query.assignTestCode) {
      void router.push(ROUTES.MISSION);
      return;
    }
    goBackOrHome();
  };

  return (
    <div
      className={`absolute top-0 left-0 flex items-center w-full h-14 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.05)] gap-2 px-[22px] justify-between bg-ielts-surface border-b-[1px] border-b-ielts-line ${className}`}
    >
      <div className="flex items-center gap-2">
        <div
          className="w-8 h-8 relative flex justify-center items-center cursor-pointer"
          onClick={handleBack}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 33 33"
            style={{ fill: 'var(--ielts-surface)', stroke: 'var(--ielts-line)' }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.08878 0.5H28.9112C30.8931 0.5 32.5 2.29067 32.5 4.5V28.5C32.5 30.709 30.8931 32.5 28.9112 32.5H4.08878C2.10688 32.5 0.5 30.709 0.5 28.5V4.5C0.5 2.29067 2.10688 0.5 4.08878 0.5Z"
            />
            <path
              d="M11.5 11.5L21.5 21.5M21.5 11.5L11.5 21.5"
              stroke="var(--ielts-fg)"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h3 className="text-ielts-fg text-base font-bold font-['Inter'] truncate max-w-[100px] lg:max-w-[inherit]">
          {lang === 'vi' ? checkPointInfo?.name || '' : checkPointInfo?.nameEn || ''}
        </h3>
      </div>
      <DiamondPopover diamonds={user?.diamond || 0} freeDiamonds={user?.freeIeltsDiamond || 0}>
        <ItemPoint
          data={(user?.diamond || 0) + (user?.freeIeltsDiamond || 0)}
          iconPrefix={iconPlus1}
          iconPrefixAfter={iconDiamond}
          onClick={() => window.open(`/${lang}${ROUTES.DIAMONDS_PREVIEW}`, '_blank')}
        />
      </DiamondPopover>
    </div>
  );
}
